export default "__VITE_ASSET__DZIYsuab__"